import Section from "./components/Section";
import { useTranslations } from "./contexts/Translation";
import { usePendingOrganization, useProfile } from "./contexts/UserProvider";
import { Info } from "@emotion-icons/material/Info";
import Button, { LinkButton } from "./components/Button/Button";
import { useNavigate } from "react-router-dom";
import { H3 } from "./components/Headers/Headings";
import styles from "./CheckSubscription.module.css";

const CheckSubscription = () => {
  const profile = useProfile();
  const t = useTranslations("dashboard");
  const navigate = useNavigate();
  const pendingOrganization = usePendingOrganization();

  if (pendingOrganization !== null) {
    return (
      <Section>
        <div className={styles.notice} data-testid='pending-approval'>
          <Info size='1.5rem' />
          <div className={styles.content}>
            <H3 variant='noTop'>{t("pendingApprovalTitle")}</H3>
            <p className={styles.description}>{t("pendingApprovalBody", pendingOrganization)}</p>
          </div>
        </div>
      </Section>
    );
  }

  if (["individual", "recurring", "org"].includes(profile?.subscription || "")) {
    return null;
  }

  return (
    <Section>
      <div className={styles.notice}>
        <Info size='1.5rem' />
        <div className={styles.content}>
          <H3 variant='noTop'>{t("noOrgTitle")}</H3>
          <p className={styles.description}>{t("noOrgDescription")}</p>
          <div className={styles.actions}>
            <Button onClick={() => navigate(`/pricing`)}>{t("pricing.viewPlans")}</Button>
            <LinkButton onClick={() => navigate(`/join-organization`)}>{t("joinOrganization")}</LinkButton>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default CheckSubscription;
